import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { useRepairHistoryModel } from "../repairHistoryModel";

export default () => {
    const {
    } = useRepairHistoryModel();
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}